import { axiosInstance } from "./axios";
import useCustomMutation from "hooks/useCustomMutation";
import { IError } from "dto/IError";

const receiveDeliverance = (payload: { id: string }) => {
  return axiosInstance.get(`/courtPortal/receive?id=${payload.id}`);
};

const useReceiveDeliverance = () => {
  return useCustomMutation(receiveDeliverance);
};

const getEpok = (payload: { id: string }) => {
  return axiosInstance.get(`/courtPortal/confirmation?id=${payload.id}`);
};

const useGetEpok = () => {
  return useCustomMutation(getEpok);
};

const preview = ({
  id,
  callback,
}: {
  id: string;
  callback?: (progress: any) => void;
}) => {
  return axiosInstance.get(`/courtPortal/preview?id=${id}`, {
    responseType: "arraybuffer",
    onDownloadProgress: (progress) => {
      callback?.(progress);
    },
  });
};

const usePreview = () => {
  return useCustomMutation(preview);
};

const previewPdf = ({
  id,
  callback,
}: {
  id: string;
  callback?: (progress: any) => void;
}) => {
  return axiosInstance.get(`/ksef/preview?number=${id}`, {
    responseType: "arraybuffer",
    onDownloadProgress: (progress) => {
      callback?.(progress);
    },
  });
};

const usePreviewPdf = () => {
  return useCustomMutation(previewPdf);
};

const download = (
  payload: { id: string },
  callback?: (progress: any) => void
) => {
  return axiosInstance.get(`/courtPortal/download?id=${payload.id}`, {
    responseType: "arraybuffer",
    onDownloadProgress: (progress) => {
      callback?.(progress);
    },
  });
};

const useDownload = () => {
  return useCustomMutation(download);
};

const sync = (): Promise<{ data: IError }> => {
  return axiosInstance.post("/courtPortal/sync");
};

const useSync = () => {
  return useCustomMutation(sync);
};

export default {
  useReceiveDeliverance,
  usePreview,
  useDownload,
  useSync,
  useGetEpok,
  usePreviewPdf,
};
